import React from 'react';
import { useState, useContext, useEffect } from 'react';

import {
	Grid,
	InputAdornment,
	IconButton,
	TextField,
	Button,
	Dialog,
	DialogActions,
	DialogContent,
	DialogTitle,
	FormControl,
	InputLabel,
	Select,
	MenuItem,
	FormHelperText,
} from '@material-ui/core';
import { Autocomplete } from '@material-ui/lab';

import CheckCircleRoundedIcon from '@material-ui/icons/CheckCircleRounded';
import EditIcon from '@material-ui/icons/Edit';

//Styles
import useStyles from './styles';

//Context
import { ClientesContext } from '../../views/clientes/context';
import { APIContext } from '../../../context'

//hook
import useFormValidation from '../../../hooks/formValidation'
import validateClienteForm from './validations';
import validateClienteFormUpdate from './validations2';

const ClienteDialogForm = ({ dialogOpen, handleClose, array, edit }) => {

	const classes = useStyles();

	// Vehiculo Context
	const {
		form,
		tipo_ide,
		estado,
	} = useContext(ClientesContext);

	//APIContext
	const {  createCliente,  updateCliente, listCiudad, ciudad } = useContext(APIContext);
    const [inputValue, setInputValue] = useState('');

	const [enabledFields, setEnabledFields] = useState({
		cli_id: true,
		cli_nombre: true,
		cli_tipide: true,
		cli_numide: true,
		ciu_id: true,
		cli_email: true,
		cli_telefono: true,
		cli_celular: true,
		cli_direccion: true,
		cli_estado: true,
	});

	// Validation Hook
	const funct = edit ? updateCliente : createCliente;
	const validation = edit ? validateClienteFormUpdate : validateClienteForm;
	if (!edit) {
		form["cli_estado"] = 1;
	}
	const [updatedFields, setUpdatedFields] = useState([]);
	const {
		fields,
		errors,
		handleSubmit,
		handleChange,
		handleBlur,
		handleAutoCompleteBlur,
		clearFields,
		clearErrors,
		setFields,
		readyToSubmit } = useFormValidation(form, validation, funct, handleClose);

	const [clearer, setClearer] = useState(null);
	const [active, setactive] = useState(null);

	useEffect(() => {
		listCiudad();
	}, []);

	useEffect(() => {
		if (clearer === true) {
			clearFields();
			clearErrors();
			setClearer(false);
		}
	}, [clearer, errors]);

	useEffect(() => {
		if (edit && array[0]) {
			setFields(array[0]);
		}
	}, [array]);

	const cleanEnabledFields = () => {
		setEnabledFields({
			cli_id: true,
			cli_nombre: true,
			cli_tipide: true,
			cli_numide: true,
			ciu_id: true,
			cli_email: true,
			cli_telefono: true,
			cli_celular: true,
			cli_direccion: true,
			cli_estado: true,
		})
	}
	return (
		<>
			<Dialog
				open={dialogOpen}
				onClose={() => { handleClose(); setClearer(true); setUpdatedFields([]); cleanEnabledFields(); }}
				aria-labelledby="alert-dialog-title"
				aria-describedby="alert-dialog-description"
				maxWidth={'md'}
				fullWidth={true}
			>
				<DialogTitle id="alert-dialog-aprobar-causa-title">
					<Grid container spacing={3} justify="space-between">
						<Grid item xs={12} md={9} lg={9}>
							Crear nuevo registro
          				</Grid>
					</Grid>
				</DialogTitle>

				<DialogContent dividers>

					<div className={classes.root}>
						<Grid container spacing={3} justify="space-between">
							<Grid item xs={12} sm={6}>
								<TextField
									fullWidth
									id="cli_nombre"
									name="cli_nombre"
									label="Nombre Completo"
									value={fields.cli_nombre || ""}
									onChange={(e) => {
										handleChange(e);
										if (!updatedFields.includes("cli_nombre")) {
											setUpdatedFields([...updatedFields, "cli_nombre"]);
										}
									}}
									onBlur={(e) => { handleBlur(e); cleanEnabledFields(); }}
									autoFocus
									error={("cli_nombre" in errors)}
									helperText={("cli_nombre" in errors) ? errors.cli_nombre : 'Nombre del cliente'}
									onMouseOver={() => { setactive("cli_nombre") }}
									onMouseLeave={() => { setactive(null) }}
									InputProps={{
										readOnly: enabledFields.cli_nombre && edit,
										endAdornment:
											<>
												{
													active === "cli_nombre" && edit &&
													<InputAdornment position="end">
														<IconButton
															aria-label="edit"
															className={classes.margin}
															onClick={() => {
																setEnabledFields({ ...enabledFields, cli_nombre: false });
																document.getElementById("cli_nombre").focus();
															}}
														>
															<EditIcon fontSize="small" />
														</IconButton>
													</InputAdornment>
												}
											</>
									}}
								/>

							</Grid>
							<Grid item xs={6} sm={3}>
								<FormControl className={classes.formControl} error={("cli_tipide" in errors)}>
									<InputLabel id="select-label">Tipo de identificación</InputLabel>
									<Select

										autoWidth
										labelId="select-label"
										id="cli_tipide"
										name="cli_tipide"
										value={fields.cli_tipide ? fields.cli_tipide : ""}
										onChange={(e) => {
											handleChange(e);
											if (!updatedFields.includes("cli_tipide")) {
												setUpdatedFields([...updatedFields, "cli_tipide"]);
											}

										}}
										onBlur={(e) => { handleBlur(e); cleanEnabledFields(); }}
										onMouseOver={() => { setactive("cli_tipide") }}
										onMouseLeave={() => { setactive(null) }}
										readOnly={enabledFields.cli_tipide && edit}
										endAdornment={
											<>
												{
													active === "cli_tipide" && edit &&
													<InputAdornment position="start">
														<IconButton
															aria-label="edit"
															className={classes.margin}
															onClick={() => {
																setEnabledFields({ ...enabledFields, cli_tipide: false });
																document.getElementById("cli_tipide").focus();
															}}
														>
															<EditIcon fontSize="small" />
														</IconButton>
													</InputAdornment>
												}
											</>
										}
									>
										{
											tipo_ide.map((tipo) => (
												<MenuItem key={tipo.tipo + tipo.value} value={tipo.value}>{tipo.tipo}</MenuItem>
											))
										}

									</Select>
									<FormHelperText>{("cli_tipide" in errors) ? errors.cli_tipide : 'Seleccione el tipo de identificación'}</FormHelperText>
								</FormControl>
							</Grid>
							<Grid item xs={6} sm={3}>
								<TextField
									fullWidth
									id="cli_numide"
									name="cli_numide"
									label="Número de identificación"
									value={fields.cli_numide || ""}
									onChange={(e) => {
										handleChange(e);
										if (!updatedFields.includes("cli_numide")) {
											setUpdatedFields([...updatedFields, "cli_numide"]);
										}

									}}
									onBlur={(e) => { handleBlur(e); cleanEnabledFields(); }}
									error={("cli_numide" in errors)}
									helperText={("cli_numide" in errors) ? errors.cli_numide : 'Número de identificación'}
									onMouseOver={() => { setactive("cli_numide") }}
									onMouseLeave={() => { setactive(null) }}
									InputProps={{
										readOnly: enabledFields.cli_numide && edit,
										endAdornment:
											<>
												{
													active === "cli_numide" && edit &&
													<InputAdornment position="end">
														<IconButton
															aria-label="edit"
															className={classes.margin}
															onClick={() => {
																setEnabledFields({ ...enabledFields, cli_numide: false });
																document.getElementById("cli_numide").focus();
															}}
														>
															<EditIcon fontSize="small" />
														</IconButton>
													</InputAdornment>
												}
											</>
									}}
								/>
							</Grid>
							<Grid item xs={12} sm={4}>
                            <Autocomplete
								id="ciu_id"
								name="ciu_id"
								defaultValue={fields.ciu_nombre !== '' && {ciu_nombre:fields.ciu_nombre}}
								options={ciudad.sort((a, b) => -b.ciu_nombre.localeCompare(a.ciu_nombre))}
                                getOptionLabel={(ciudad) => (ciudad.ciu_nombre)  || ""}
                                inputValue={ inputValue }
                                onInputChange={(event, newInputValue) => {
									setInputValue(newInputValue)
                                }} 
                                onChange={(e,newValue) => {
									if (!updatedFields.includes("ciu_id")) {
										setUpdatedFields([...updatedFields, "ciu_id"]);
									}
									handleAutoCompleteBlur( newValue.ciu_id , 'ciu_id' , handleAutoCompleteBlur( e.target.textContent , 'ciu_nombre'));
									;
								}}
								onBlur={(e) => { cleanEnabledFields(); }}
                                //getOptionSelected={(ciudad) => ciudad.ciu_nombre || ""}
								size="small"
								onMouseOver={() => { setactive("ciu_id") }}
								onMouseLeave={() => { setactive(null) }}
                                disableClearable={true}
                                classes={{
                                    inputRoot: classes.InputBase
                                }}
                                fullWidth
                                renderInput={(params) =>
                                    <TextField
                                        {...params}
										placeholder="Ciudad"
										error={("ciu_id" in errors)}
										label="Ciudad"
                                        //error={inputError===true && dataCliente.ciu_id === 0}
                                    />}
                                    
                            />
							<FormHelperText>{("ciu_id" in errors) ? errors.ciu_id : 'Ciudad del cliente'}</FormHelperText>
							</Grid>
							<Grid item xs={6} sm={8}>
								<TextField
									fullWidth
									multiline
									id="cli_direccion"
									name="cli_direccion"
									label="Dirección"
									value={fields.cli_direccion || ""}
									onChange={(e) => {
										handleChange(e);
										if (!updatedFields.includes("cli_direccion")) {
											setUpdatedFields([...updatedFields, "cli_direccion"]);
										}

									}}
									onBlur={(e) => { handleBlur(e); cleanEnabledFields(); }}
									//disabled={disabled} //need it when opened from the register

									error={("cli_direccion" in errors)}
									helperText={("cli_direccion" in errors) ? errors.cli_direccion : 'Dirección del cliente'}
									onMouseOver={() => { setactive("cli_direccion") }}
									onMouseLeave={() => { setactive(null) }}
									InputProps={{
										readOnly: enabledFields.cli_direccion && edit,
										endAdornment:
											<>
												{
													active === "cli_direccion" && edit &&
													<InputAdornment position="start">
														<IconButton
															aria-label="edit"
															className={classes.margin}
															onClick={() => {
																setEnabledFields({ ...enabledFields, cli_direccion: false });
																document.getElementById("cli_direccion").focus();
															}}
														>
															<EditIcon fontSize="small" />
														</IconButton>
													</InputAdornment>
												}
											</>
									}}
								/>
							</Grid>
							<Grid item xs={6} sm={4}>
								<TextField
									fullWidth
									id="cli_email"
									name="cli_email"
									label="Email"
									value={fields.cli_email || ""}
									onChange={(e) => {
										handleChange(e);
										if (!updatedFields.includes("cli_email")) {
											setUpdatedFields([...updatedFields, "cli_email"]);
										}

									}}
									onBlur={(e) => { handleBlur(e); cleanEnabledFields(); }}

									error={("cli_email" in errors)}
									helperText={("cli_email" in errors) ? errors.cli_email : 'Email del cliente'}
									onMouseOver={() => { setactive("cli_email") }}
									onMouseLeave={() => { setactive(null) }}
									InputProps={{
										readOnly: enabledFields.cli_email && edit,
										endAdornment:
											<>
												{
													active === "cli_email" && edit &&
													<InputAdornment position="start">
														<IconButton
															aria-label="edit"
															className={classes.margin}
															onClick={() => {
																setEnabledFields({ ...enabledFields, cli_email: false });
																document.getElementById("cli_email").focus();
															}}
														>
															<EditIcon fontSize="small" />
														</IconButton>
													</InputAdornment>
												}
											</>
									}}
								/>
							</Grid>

							<Grid item xs={6} sm={4}>
								<TextField
									fullWidth
									id="cli_telefono"
									name="cli_telefono"
									label="Teléfono"
									value={fields.cli_telefono || ""}
									onChange={(e) => {
										handleChange(e);
										if (!updatedFields.includes("cli_telefono")) {
											setUpdatedFields([...updatedFields, "cli_telefono"]);
										}

									}}
									onBlur={(e) => { handleBlur(e); cleanEnabledFields(); }}

									error={("cli_telefono" in errors)}
									helperText={("cli_telefono" in errors) ? errors.cli_telefono : 'Teléfono del cliente'}
									onMouseOver={() => { setactive("cli_telefono") }}
									onMouseLeave={() => { setactive(null) }}
									InputProps={{
										readOnly: enabledFields.cli_telefono && edit,
										endAdornment:
											<>
												{
													active === "cli_telefono" && edit &&
													<InputAdornment position="start">
														<IconButton
															aria-label="edit"
															className={classes.margin}
															onClick={() => {
																setEnabledFields({ ...enabledFields, cli_telefono: false });
																document.getElementById("cli_telefono").focus();
															}}
														>
															<EditIcon fontSize="small" />
														</IconButton>
													</InputAdornment>
												}
											</>
									}}
								/>
							</Grid>
							<Grid item xs={6} sm={4}>
								<TextField
									fullWidth
									id="cli_celular"
									name="cli_celular"
									label="Celular"
									value={fields.cli_celular || ""}
									onChange={(e) => {
										handleChange(e);
										if (!updatedFields.includes("cli_celular")) {
											setUpdatedFields([...updatedFields, "cli_celular"]);
										}

									}}
									onBlur={(e) => { handleBlur(e); cleanEnabledFields(); }}

									error={("cli_celular" in errors)}
									helperText={("cli_celular" in errors) ? errors.cli_celular : 'Celular del cliente'}
									onMouseOver={() => { setactive("cli_celular") }}
									onMouseLeave={() => { setactive(null) }}
									InputProps={{
										readOnly: enabledFields.cli_celular && edit,
										endAdornment:
											<>
												{
													active === "cli_celular" && edit &&
													<InputAdornment position="start">
														<IconButton
															aria-label="edit"
															className={classes.margin}
															onClick={() => {
																setEnabledFields({ ...enabledFields, cli_celular: false });
																document.getElementById("cli_celular").focus();
															}}
														>
															<EditIcon fontSize="small" />
														</IconButton>
													</InputAdornment>
												}
											</>
									}}
								/>
							</Grid>
							
							{edit &&
								<Grid item xs={6} sm ={4}>
									<FormControl className={classes.formControl} error={("cli_estado" in errors)} >
										<InputLabel id="select-label">Estado</InputLabel>
										<Select
											autoWidth
											labelId="select-label"
											id="cli_estado"
											name="cli_estado"
											value={fields.cli_estado ? fields.cli_estado : ""}
											onChange={(e) => {
												handleChange(e);
												if (!updatedFields.includes("cli_estado")) {
													setUpdatedFields([...updatedFields, "cli_estado"]);
												}
											}}
											onBlur={(e) => { handleBlur(e); cleanEnabledFields(); }}
											onMouseOver={() => { setactive("cli_estado") }}
											onMouseLeave={() => { setactive(null) }}
											readOnly={enabledFields.cli_estado && edit}
											endAdornment={
												<>
													{
														active === "cli_estado" && edit &&
														<InputAdornment position="start">
															<IconButton
																aria-label="edit"
																className={classes.margin}
																onClick={() => {
																	setEnabledFields({ ...enabledFields, cli_estado: false });
																	document.getElementById("cli_estado").focus();
																}}
															>
																<EditIcon fontSize="small" />
															</IconButton>
														</InputAdornment>
													}
												</>
											}
										>
											{
												estado.map((estado) => (
													<MenuItem key={estado.tipo + estado.value} value={estado.value}>{estado.tipo}</MenuItem>
												))
											}

										</Select>
										<FormHelperText>{("cli_estado" in errors) ? errors.cli_estado : 'Seleccione el estado del cliente'}</FormHelperText>
									</FormControl>
								</Grid>
							}


						</Grid>
					</div>

				</DialogContent>
				<DialogActions>
					<Button
						onClick={() => { handleClose(); setClearer(true); setUpdatedFields([]); cleanEnabledFields(); }}
						variant="outlined"
						color="secondary"
					>
						Cancelar
          				</Button>
					{edit ?
						<Button
							//type="submit"
							variant="contained"
							color="primary"
							disabled={!readyToSubmit || updatedFields.length === 0}

							onClick={(e) => { handleSubmit(e); handleClose(); setClearer(true); setUpdatedFields([]); cleanEnabledFields(); }}
						>
							<CheckCircleRoundedIcon />
            				Guardar Cambios
          				</Button>
						:
						<Button
							//type="submit"
							variant="contained"
							color="primary"
							disabled={!readyToSubmit}
							onClick={(e) => { handleSubmit(e); handleClose(); setClearer(true); }}
						>
							<CheckCircleRoundedIcon />
            				Guardar
          				</Button>
					}

				</DialogActions>

			</Dialog>

		</>
	)
}
export default ClienteDialogForm;